import { HTMLProps } from "react"

function generateGradientSquare(id: string): React.CSSProperties {
  // Create a simple hash from the string
  const hash = id.split("").reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc)
  }, 0)

  // Generate three colors from the hash
  const color1 = `hsl(${hash % 360}, 70%, 60%)`
  const color2 = `hsl(${(hash * 2) % 360}, 70%, 60%)`
  const angle = hash % 360

  return {
    background: `linear-gradient(${angle}deg, ${color1}, ${color2})`
  }
}

type SquareProps = {
  id?: string
} & HTMLProps<HTMLDivElement>

export const UniqueGradient = ({ id, style, ...props }: SquareProps) => {
  if (!id) id = Math.random().toString(36).substring(2, 9)

  return <div style={{ ...generateGradientSquare(id), ...style }} {...props} />
}
